import { configureStore } from '@reduxjs/toolkit';
import projectListReducer from '../features/dashboard/redux/slice.js';
import viewerReducer from '../features/viewer/redux/slice.js';
import bbsOptimiseReducer from '../features/bbsOptimization/redux/slice.js';
import requestApprovalReducer from '../features/requestApproval/redux/slice.js';
import loginReducer from '../features/login/redux/slice.js';
import quarterlyInputReducer from '../features/quarterlyInput/redux/slice.js';
import advanceSearchReducer from '../features/advanceSearch/redux/slice.js';

export const store = configureStore({
  reducer: {
    projectList: projectListReducer,
    viewer: viewerReducer,
    bbsOptimise: bbsOptimiseReducer,
    requestApproval: requestApprovalReducer,
    login: loginReducer,
    quarterlyInput: quarterlyInputReducer,
    advanceSearch: advanceSearchReducer,
  },
});
